import { useCallback } from "react";
import { baseBackendURL } from "../../helpers/baseUrl";
import { fireConversionEvent, getStoredGclid } from "../../helpers/conversionUtils";

export const useRegistrationActions = () => {
  const handleRegister = useCallback(
    async (
      e,
      {
        isDemo,
        isMobile,
        email,
        firstName,
        lastName,
        password,
        captchaToken,
        referrer,
        setError,
        setSuccessMessage,
      }
    ) => {
      e.preventDefault();
      setError("");
      setSuccessMessage("");

      try {
        let response;
        if (isDemo) {
          response = await fetch(`${baseBackendURL}/registerDemo`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ isMobile }),
            credentials: "include",
          });
        } else {
          response = await fetch(`${baseBackendURL}/register`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email,
              firstName,
              lastName,
              password,
              captchaToken,
              referrer,
              gclid: getStoredGclid(),
            }),
            credentials: "include",
          });
        }

        const data = await response.json();
        if (data.success) {
          if (!isDemo) {
            fireConversionEvent("sign_up", { method: "email" });
          }
          window.location.href = "/app";
        } else {
          setError(data.message || "Registration failed");
        }
      } catch (error) {
        console.error("Error registering:", error);
        setError("Unable to reach server. Please try again later.");
      }
    },
    []
  );

  const createDemoAccount = useCallback(
    (e, options) => {
      return handleRegister(e, {
        ...options,
        isDemo: true,
      });
    },
    [handleRegister]
  );

  const createRegularAccount = useCallback(
    (e, options) => {
      return handleRegister(e, {
        ...options,
        isDemo: false,
      });
    },
    [handleRegister]
  );

  return {
    handleRegister,
    createDemoAccount,
    createRegularAccount,
  };
};
